/**
 * Image URL utility functions
 */

/**
 * Normalize image URL to ensure it works with current domain
 * Handles both old full URLs and new relative paths
 * @param {string} url - The image URL (can be full URL or relative path)
 * @returns {string} Normalized URL that works with current domain
 */
export const normalizeImageUrl = (url) => {
  if (!url) return '';

  // If URL already starts with http/https, extract just the path
  if (url.startsWith('http://') || url.startsWith('https://')) {
    try {
      const urlObj = new URL(url);
      // Return just the pathname (e.g., /api/uploads/filename.jpg)
      return urlObj.pathname;
    } catch (e) {
      // If URL parsing fails, return as is
      return url;
    }
  }

  // If it's already a relative path, return as is
  if (url.startsWith('/')) {
    return url;
  }

  // If it's just a filename, add the /api/uploads prefix
  if (!url.includes('/')) {
    return `/api/uploads/${url}`;
  }

  return url;
};

/**
 * Get full image URL by combining with backend URL
 * @param {string} path - The relative path
 * @returns {string} Full URL
 */
export const getFullImageUrl = (path) => {
  const normalizedPath = normalizeImageUrl(path);
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';

  // If already starts with http, return as is
  if (normalizedPath.startsWith('http://') || normalizedPath.startsWith('https://')) {
    return normalizedPath;
  }

  // Combine backend URL with path
  return `${backendUrl}${normalizedPath}`;
};
